const features = [
  {
    icon: 'ri-4k-line',
    title: '1080P高清画质',
    desc: '多码率自适应，根据网络环境智能切换清晰度，热门剧集支持蓝光级画质，每一个细节都清晰可见。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-speed-up-line',
    title: '智能极速加载',
    desc: '全国多节点CDN加速，毫秒级响应。自适应码率技术确保弱网环境也能流畅播放，告别卡顿等待。',
    color: 'bg-accent-100 text-accent-800',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量正版片库',
    desc: '汇聚超过10000部电视剧资源，涵盖国产、韩剧、美剧、日剧等全品类，定期更新最全片库。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-time-line',
    title: '每日同步更新',
    desc: '热门在播剧集播出后第一时间上线，完结剧集持续补全高清版本，追剧党不再焦急等待。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-device-line',
    title: '多终端无缝切换',
    desc: '完美适配电脑、手机、平板全设备，网页打开即看无需安装。跨设备进度无缝衔接，随时随地追剧。',
    color: 'bg-accent-100 text-accent-800',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          平台优势
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          为什么选择快看影视
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-default"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${feat.color} transition-transform group-hover:scale-110`}>
                <i className={`${feat.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">{feat.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}